import { Destination } from 'components/package/expedia/enums';
import { DestinationState } from 'components/package/expedia/interfaces';

const initialDestinationState: DestinationState = {
  destination: Destination.LAS,
};

export { initialDestinationState };
